import React, { useState, useEffect } from "react";
import { Tab, Nav, Container } from "react-bootstrap";
import jsDig from "utils/jsDig";
import enTranslations from '@shopify/polaris/locales/en.json';
import {AppProvider, Page, Card, Button, Badge, List, TextContainer, TextStyle} from '@shopify/polaris';

export default function App(props) {
  const dashboardUrl = `/datapulse/shopify/app/dashboard?shop=${props.shop}`
  const teamUrl = `/datapulse/shopify/app/team?shop=${props.shop}`

  return (
    <AppProvider i18n={enTranslations}>
      <Page 
        fullWidth 
        title="DataPulse Bridge by Digital Position"
      >
        <Card title="Thank you for installing" sectioned>
          <p>With this app installed on your shopify store, Digital Position will be able to pull your performance data and display it in your metrics dashboards on DataPulse.</p>
        </Card>
        <Card title="Important information" sectioned>
          <TextContainer>
            <p className="mb-4">DataPulse Bridge is successfully <Badge status="success">Connected</Badge> to your store.</p>
            <p className="mb-4">It was installed on 
              <TextStyle variation="positive"> { props.shopify_install.updated_at.split("T")[0] }</TextStyle>
            </p>
          </TextContainer>
        </Card>
        <Card title="Metrics" sectioned>
          <TextContainer>
            <p className="mb-4">To see the metrics we have pulled from your store click the button below.</p>
            <Button primary size="medium" url={dashboardUrl}>Dashboard</Button>
          </TextContainer>
        </Card>
        <Card title="Team" sectioned>
          <TextContainer>
            <p className="mb-4">See your team members and get in touch.</p>
            <Button size="medium" url={teamUrl}>Team</Button>
          </TextContainer>
        </Card>
      </Page>
    </AppProvider>
  )
}